export enum GiftRecipientTypes {
  EMPTY = '',
  OTHER = 'OTHER',
  CHARITY = 'CHARITY',
  BROKERAGE_FIRM = 'BROKERAGE_FIRM',
  TRANSFER_AGENT = 'TRANSFER_AGENT',
}

export enum YesNoEmpty {
  EMPTY = '',
  YES = 'Yes',
  NO = 'No',
}
